import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/dashboard/auth/CustomerRegister.css';
import { Spinner } from 'react-bootstrap';

const CustomerRegister = () => {

  const navigate = useNavigate();
  const { baseUrl, setLoggedInCustomer } = useContext(AppContext);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('bride');
  const [password, setPassword] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');

  const [showPwd, setShowPwd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); // ✅ FIX 1: sirf ek jagah

  const registerCustomer = (e) => {
    e.preventDefault();

    if (password !== confirmPwd) {
      setErrorMessage('Passwords do not match');
      return;
    }

    setIsLoading(true); // ✅ FIX 2: setLoading → setIsLoading
    setErrorMessage('');

    const formdata = new FormData();
    formdata.append('firstName', firstName);
    formdata.append('lastName', lastName);
    formdata.append('email', email);
    formdata.append('phone', phone);
    formdata.append('role', role);
    formdata.append('password', password);

    axios
      .post(`${baseUrl}/customer/auth/customerSignup`, formdata)
      .then((response) => {
        if (response.data.success == true) {
          localStorage.setItem('customerEmail', email);
          localStorage.setItem('customerPassword', password);
          localStorage.setItem('loggedInCustomer', JSON.stringify(response.data.customer));
          setLoggedInCustomer(response.data.customer);
          // ✅ FIX: seedha dashboard pe — login page se guzarne ki zaroorat
          // nahi thi, wahan customerAutoLogin() dobara backend ko call kar
          // raha tha jabke customer data yahin mil chuka hai.
          navigate('/customer/dashboard');
        } else {
          setErrorMessage(response.data.message || 'Something went wrong!');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.message || 'Something went wrong!');
        setIsLoading(false);
      });
  };

  return isLoading ? ( // ✅ FIX 3: Loading → isLoading
    <div style={{ height: '100vh' }} className="d-flex justify-content-center align-items-center">
      <Spinner style={{ height: 50, width: 50 }} />
    </div>
  ) : (
    <div className="rgn-root">
      <div className="rgn-page">

        <div className="rgn-left">
          <div className="rgn-card">

            <div className="rgn-card-header">
              <p className="rgn-greeting">Start your journey 💍</p>
              <h1 className="rgn-title">Create Account</h1>
              <p className="rgn-subtitle">Join Bridely and plan your perfect wedding</p>
            </div>

            {/* ✅ autoComplete="off" pe form-level bhi lagaya — kuch browsers
                sirf form ke autoComplete attribute ko hi consistently respect
                karte hain, individual inputs ke bajaye. */}
            <form autoComplete="off">
              <div className="rgn-form-grid">

                <div className="rgn-form-group">
                  <label className="rgn-label">First Name</label>
                  <input type="text" className="rgn-input" value={firstName}
                    onChange={(e) => setFirstName(e.target.value)} autoComplete="off" required />
                </div>

                <div className="rgn-form-group">
                  <label className="rgn-label">Last Name</label>
                  <input type="text" className="rgn-input" value={lastName}
                    onChange={(e) => setLastName(e.target.value)} autoComplete="off" required />
                </div>

                {/* ✅ FIX: autoComplete="off" add kiya — pehle browser saved
                    login credentials (jaise maryam0@gmail.com) khud bhar deta
                    tha, kyunke koi autoComplete attribute set nahi tha. */}
                <div className="rgn-form-group rgn-form-group--full">
                  <label className="rgn-label">Email</label>
                  <input type="email" className="rgn-input" value={email}
                    onChange={(e) => setEmail(e.target.value)} autoComplete="off" required />
                </div>

                <div className="rgn-form-group">
                  <label className="rgn-label">Phone</label>
                  <input type="text" className="rgn-input" value={phone}
                    onChange={(e) => setPhone(e.target.value)} autoComplete="off" />
                </div>

                {/* <div className="rgn-form-group">
                  <label className="rgn-label">I am a</label>
                  <select className="rgn-select" value={role}
                    onChange={(e) => setRole(e.target.value)}>
                    <option value="bride">Bride</option>
                    <option value="groom">Groom</option>
                    <option value="family">Family Member</option>
                    <option value="planner">Wedding Planner</option>
                  </select>
                </div> */}

                {/* ✅ FIX: autoComplete="new-password" — password fields ke
                    liye "off" browsers/password-managers ke against reliably
                    kaam nahi karta; "new-password" hi standard tareeqa hai
                    browser ko batane ka ke ye saved password suggest na kare. */}
                <div className="rgn-form-group rgn-form-group--full">
                  <label className="rgn-label">Password</label>
                  <div className="rgn-input-wrap">
                    <input type={showPwd ? 'text' : 'password'} className="rgn-input"
                      value={password} onChange={(e) => setPassword(e.target.value)}
                      autoComplete="new-password" required />
                    <button type="button" className="rgn-eye-btn"
                      onClick={() => setShowPwd(!showPwd)}>
                      {showPwd ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>

                <div className="rgn-form-group rgn-form-group--full">
                  <label className="rgn-label">Confirm Password</label>
                  <div className="rgn-input-wrap">
                    <input type={showConfirm ? 'text' : 'password'} className="rgn-input"
                      value={confirmPwd} onChange={(e) => setConfirmPwd(e.target.value)}
                      autoComplete="new-password" required />
                    <button type="button" className="rgn-eye-btn"
                      onClick={() => setShowConfirm(!showConfirm)}>
                      {showConfirm ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>

              </div>

              {errorMessage && (
                <p style={{ color: 'red', marginBottom: '10px' }}>{errorMessage}</p>
              )}

              <button type="button" className="rgn-btn-submit"
                disabled={isLoading} onClick={registerCustomer}>
                {isLoading ? 'Creating account... ⏳' : 'Create Account →'}
              </button>

            </form>

            <div className="lgn-register-row">
              Already have an account?{' '}
              <Link to="/customer/login" className="mnb-btn-login">Login here</Link>
            </div>

          </div>
        </div>

        <div className="rgn-right">
          <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=85"
            alt="Wedding" className="rgn-bg-img" />
        </div>

      </div>
    </div>
  );
};

export default CustomerRegister;